<script setup lang="ts">
import Eye from '../icons/Eye.vue';
import EyeClosed from '../icons/EyeClosed.vue';

const {
  errorMessages = [],
  readonly = false,
  disabled = false,
  label = 'Password',
  placeholder = '',
  rounded = 'lg',
} = defineProps<{
  errorMessages?: string | string[];
  readonly?: boolean;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  rounded?: string | number | boolean;
}>();

const password = defineModel();

const showPassword = ref(false);
function togglePasswordVisibility() {
  showPassword.value = !showPassword.value;
}
</script>

<template>
  <v-text-field
    v-model="password"
    flat
    variant="solo-filled"
    autocomplete="current-password"
    hide-details="auto"
    :error-messages="errorMessages"
    :rounded="rounded"
    :placeholder="placeholder"
    :label="label"
    :readonly="readonly"
    :disabled="disabled"
    :type="showPassword ? 'text' : 'password'"
    data-testid="password"
  >
    <template #append-inner>
      <slot name="append-inner">
        <v-icon data-testid="password-toggle" @click="togglePasswordVisibility">
          <component :is="showPassword ? EyeClosed : Eye" :color="showPassword ? '#050529' : '#050529'" />
        </v-icon>
      </slot>
    </template>
  </v-text-field>
</template>

<style></style>
